import React, { useState } from 'react';

function Demographics({ onComplete }) {
  const [formData, setFormData] = useState({
    age: '',
    gender: '',
    expertise: 4,
    artCourses: '',
    museumVisits: '',
    artPractice: ''
  });

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.age && formData.gender && formData.artCourses && formData.museumVisits && formData.artPractice) {
      onComplete(formData);
    }
  };

  return (
    <div className="phase-container">
      <h1>Background Information</h1>
      <p>Please answer a few questions about yourself before we begin.</p>
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="age">Age:</label>
          <input
            type="number"
            id="age"
            min="18"
            max="100"
            value={formData.age}
            onChange={(e) => handleChange('age', e.target.value)}
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="gender">Gender:</label>
          <select
            id="gender"
            value={formData.gender}
            onChange={(e) => handleChange('gender', e.target.value)}
            required
          >
            <option value="">Select...</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="non-binary">Non-binary</option>
            <option value="prefer-not-to-say">Prefer not to say</option>
          </select>
        </div>
        
        <div className="form-group">
          <label>Rate your knowledge of art history:</label>
          <div className="likert-scale">
            {[1, 2, 3, 4, 5, 6, 7].map(value => (
              <div key={value} className="likert-option">
                <input
                  type="radio"
                  id={`expertise-${value}`}
                  name="expertise"
                  value={value}
                  checked={formData.expertise === value}
                  onChange={() => handleChange('expertise', value)}
                />
                <label htmlFor={`expertise-${value}`}>
                  {value === 1 ? 'No\nknowledge' : 
                   value === 7 ? 'Expert\nknowledge' : value}
                </label>
              </div>
            ))}
          </div>
        </div>
        
        <div className="form-group">
          <label>Have you taken any university-level art history courses?</label>
          <div className="radio-group">
            <label className="radio-option">
              <input
                type="radio"
                name="artCourses"
                value="yes"
                checked={formData.artCourses === 'yes'}
                onChange={(e) => handleChange('artCourses', e.target.value)}
                required
              />
              <span>Yes</span>
            </label>
            <label className="radio-option">
              <input
                type="radio"
                name="artCourses"
                value="no"
                checked={formData.artCourses === 'no'}
                onChange={(e) => handleChange('artCourses', e.target.value)}
                required
              />
              <span>No</span>
            </label>
          </div>
        </div>
        
        <div className="form-group">
          <label>How often do you visit art museums or galleries?</label>
          <select
            value={formData.museumVisits}
            onChange={(e) => handleChange('museumVisits', e.target.value)}
            required
          >
            <option value="">Select...</option>
            <option value="never">Never</option>
            <option value="rarely">Rarely (less than once a year)</option>
            <option value="occasionally">Occasionally (1-3 times a year)</option>
            <option value="frequently">Frequently (4-11 times a year)</option>
            <option value="very-frequently">Very frequently (monthly or more)</option>
          </select>
        </div>
        
        <div className="form-group">
          <label>Do you practice any form of visual art yourself?</label>
          <div className="radio-group">
            <label className="radio-option">
              <input
                type="radio"
                name="artPractice"
                value="yes-professional"
                checked={formData.artPractice === 'yes-professional'}
                onChange={(e) => handleChange('artPractice', e.target.value)}
                required
              />
              <span>Yes, professionally</span>
            </label>
            <label className="radio-option">
              <input
                type="radio"
                name="artPractice"
                value="yes-hobby"
                checked={formData.artPractice === 'yes-hobby'}
                onChange={(e) => handleChange('artPractice', e.target.value)}
                required
              />
              <span>Yes, as a hobby</span>
            </label>
            <label className="radio-option">
              <input
                type="radio"
                name="artPractice"
                value="no"
                checked={formData.artPractice === 'no'}
                onChange={(e) => handleChange('artPractice', e.target.value)}
                required
              />
              <span>No</span>
            </label>
          </div>
        </div>
        
        <div className="button-group">
          <button type="submit">
            Continue to Experiment
          </button>
        </div>
      </form>
    </div>
  );
}

export default Demographics;